<!--
 * @Author: lishiqiao
 * @Date: 2022-01-13 15:07:16
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-07-14 10:23:22
-->
<template>
  <div class="page-list">
    <!-- 年度目标完成情况汇总表-育苗 -->
    <SummaryPage v-if="pageType === 'summary'" @getPageType="getPageType" />
    <!-- 年度目标完成情况明细表-育苗 -->
    <DetailPage v-if="pageType === 'detail'" @getPageType="getPageType" />
  </div>
</template>

<script>
import SummaryPage from "./ym-sales-customer-summary.vue";
import DetailPage from "./ym-sales-customer-details.vue";
export default {
  name: "customer",
  data() {
    return {
      pageType: "summary", // summary汇总表,detail明细表
    };
  },
  methods: {
    getPageType(pageType) {
      this.pageType = pageType;
    },
  },
  components: {
    SummaryPage,
    DetailPage,
  },
};
</script>

<style lang="less" scoped>
</style>